import React, { Component, PureComponent } from 'react';
import ReactTable from 'react-table';
import classnames from 'classnames';
import 'react-table/react-table.css';
import {
  Switch,
  Route,
  Link
} from "react-router-dom";

import APIClient from './Api';
import EditPopup from './EditPopup';

import Filters from './Filters';
import HomeTestimonials from './HomeTestimonials';
import Parameters from './Parameters';
import './BackOffice.scss';


const api = new APIClient();


class BackOfficeTable extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      nbPages: -1
    };
    this.table = React.createRef();
  }

  fetchData = (filters) => {
    if (filters) {
      // Modify filters only if new filters are given
      this.table.current.filters = filters;
    }
    this.table.current.fireFetchData();
  }

  render() {
    const columns = [
    {
      Header: 'Sél.',
      accessor: 'id',
      sortable: false,
      maxWidth: 30,
      Cell: props => {
        const contribId = props.original.id,
        moderated = props.original.moderated,
        onChange = () => {this.props.onRowSelectToggle(contribId, moderated)};
        return <input
                  type="checkbox"
                  checked={this.props.selectedRows[contribId] !== undefined}
                  onChange={onChange}></input>
        }
    },
    {
      Header: 'ID',
      accessor: 'id',
      maxWidth: 30,
    }, {
      Header: 'Date de création',
      accessor: 'created_at',
      minWidth: 200
    }, {
      Header: 'Prénom',
      accessor: 'firstname'/*,
      Cell: props => <span className='number'>{props.value}</span> // Custom cell components!*/
    },{
      /*id: 'Prénom', // Required because our accessor is not a string*/
      Header: 'Nom',
      accessor: 'lastname'
      /*accessor: d => d.friend.name // Custom value accessors!*/
    },
    {
      Header: 'Age',
      accessor: 'age',
      maxWidth: 50,
    },
    {
      Header: 'Modération',
      accessor: 'moderated',
      Cell: (props) => {
        const contribId = props.original.id,
          onClick = () => {this.props.onEditEntry(contribId, this.state.data)};
        return props.value ?
        (<button class="button is-danger" onClick={onClick}>Non affiché sur le site</button>)
      : (<button class="button is-info" onClick={onClick}>Affiché sur le site</button>)
      },
      minWidth: 200,
      className: 'gp-bo-moderation'
    },
    {
      Header: 'Message',
      accessor: 'message',
      minWidth: 200
    },
    {
      Header: 'Département / territoire',
      accessor: 'administrative_unit_name',
      minWidth: 100,
      sortable: false   // Disable sorting. Be careful, this is an old option (https://github.com/tannerlinsley/react-table/blob/v6.11.4/src/propTypes.js)
    },
    {
      Header: 'E-mail',
      accessor: 'email',
      minWidth: 100
    },
  ]
    return (
          <ReactTable
            data={this.state.data}
            columns={columns}
            defaultPageSize={500}
            pages={this.state.nbPages}
            manual
            multiSort={false}
            onFetchData={async (state, instance) => {
              this.setState({loading: true});
              const data = await api.getBackOfficeData(
                state.page,
                state.sorted,
                instance.filters
              );
              this.setState(
                {
                  data: data.rows,
                  nbPages: data.pages,
                  loading: false
                }
              );
              this.props.onSetTotal(data.total);
            }}
            className="gp-bo-table -striped -highlight"
            previousText="Précédent"
            nextText="Suivant"
            loading={this.state.loading}
            loadingText=""
            noDataText="Pas de données"
            showPageSizeOptions={false}
            showPageJump={false}
            pageText="Page"
            ofText="de"
            rowsText="lignes"
            ref={this.table}
            onSetTotal={this.props.onSetTotal}
          />);
  }
}


function ItemMenu({ to, ...rest }) {
  return (
    <Route
      path={to}
      children={({ match }) => (
        <li className={match && match.isExact ? "is-active" : ""}>
          <Link to={to} {...rest} />
        </li>
      )}
    />
  );
}


class BackOffice extends Component {

  constructor(props) {
    super(props);
    this.state = {
      editing: null,
      contribIdList: null,
      selectedRows: {},
      total: 0
    };
    this.table = React.createRef();
  }

  onEditEntry = (contribId, data) => {
    this.setState({editing: contribId, contribIdList: this.get_ids_as_array(data)});
  }

  onClose = () => {
    this.setState({editing: null});
    // Refresh table
    this.table.current.fetchData();
  }

  onRowSelectToggle = (contribId, moderated) => {
    let rows = { ...this.state.selectedRows };
    if (rows[contribId] !== undefined) {
      delete rows[contribId];
    } else {
      rows[contribId] = moderated;
    }
    this.setState({selectedRows: rows});
  }

  onSetTotal = (total) => {
    this.setState({total: total})
  }

  get_ids_as_array = (data_list) => {
    return data_list.map(item => item.id);
  }

  getNumberOfSelectedRows() {
    return Object.keys(this.state.selectedRows).length;
  }

  toModerateOrNot() {
    // Depending on the existing status of the majority of selected rows, we moderate or not
    let nbModerated = Object.values(this.state.selectedRows).map((a) => a ? 1 : 0).reduce((a, b) => a + b)
    return nbModerated < this.getNumberOfSelectedRows() / 2
  }

  getModerationActionLabel() {
    let nb = this.getNumberOfSelectedRows();
    return 'Faire ' + (this.toModerateOrNot() ? 'disparaître' : 'apparaître') + ' les ' + nb + ' soutiens sélectionnés';
  }

  moderate = async () => {
    let moderateOrNot = this.toModerateOrNot();
    await api.moderateSeveral(Object.keys(this.state.selectedRows), moderateOrNot);
    this.setState({selectedRows: {}});
    // Refresh table
    this.table.current.fetchData();
  }

  handleFiltersSubmit = (filters) => {
    // We pass filters directly to the table component.. uggh
    this.table.current.fetchData(filters);
  }

  downloadCsvContribs = async() => {

      return await api.getBackOfficeCsvExport(
                    this.table.current.table.current.state.sorted,
                    this.table.current.table.current.filters
                  );
  }

  render() {
    return (
      <div className="gp-bo-content">
        <section>
          { this.state.editing != null ?
            <EditPopup
              contribId={this.state.editing}
              contribIdList={this.state.contribIdList}
              onClose={this.onClose}/> : '' }
          <h1 className="title">Administration Affaire Du Siècle</h1>
          <div className="tabs is-boxed">
            <ul>
                <ItemMenu to="/backoffice">Modération</ItemMenu>
                <ItemMenu to="/backoffice/hometestimonials">Témoignages page d'accueil</ItemMenu>
                <ItemMenu to="/backoffice/params">Paramètres</ItemMenu>
              </ul>
          </div>
          <Switch>
            <Route exact path="/backoffice">
              <div className="is-clearfix">
                <a onClick={this.downloadCsvContribs} className="is-pulled-right is-right">
                  <button className="is-pulled-right is-right button" >Téléchargement Csv</button>
                </a>
                <Filters onSubmit={this.handleFiltersSubmit}/>
                <h3 className="gp-bo-subtitle subtitle">Liste des contributions {this.state.total ? "(" + this.state.total + ")" : ''}</h3>
              </div>
              <div className="is-clearfix">{ this.getNumberOfSelectedRows() > 1 ? <button
                                                    className={classnames("button gp-bo-multimoderation", this.toModerateOrNot() ? "is-danger" : "is-info")}
                                                    onClick={this.moderate}>{this.getModerationActionLabel()}</button> : ''}
              </div>
              <BackOfficeTable
                onRowSelectToggle={this.onRowSelectToggle}
                onEditEntry={this.onEditEntry}
                ref={this.table}
                selectedRows={this.state.selectedRows}
                onSetTotal={this.onSetTotal}/>
            </Route>
            <Route path="/backoffice/hometestimonials">
              <HomeTestimonials />
            </Route>
            <Route path="/backoffice/params">
              <Parameters />
            </Route>
          </Switch>
        </section>
      </div>
    )
  }

}

export default BackOffice;
